module.exports = "<p>\r\n  house-images works!\r\n</p>\r\n"